import { useState } from "react"
import { useNavigate } from "react-router-dom"
import api from "../../services/api"

export default function AdminLogin() {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError("")
    setLoading(true)
    try {
      const res = await api.post("/auth/admin/login", { email, password })
      if (res?.data?.message === "successful") {
        navigate("/admin/dashboard")
      } else {
        setError(res?.data?.data || "Login failed")
      }
    } catch (e) {
      setError(e?.response?.data?.data || e?.response?.data?.message || "Login failed")
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100">
      <div className="card w-96 bg-base-100 shadow-xl">
        <div className="card-body">
          <h1 className="card-title">Admin Login</h1>
          <form onSubmit={handleSubmit}>
            <div className="form-control">
              <label className="label">Email</label>
              <input type="email" className="input input-bordered" value={email} onChange={(e) => setEmail(e.target.value)} required />
            </div>
            <div className="form-control">
              <label className="label">Password</label>
              <input type="password" className="input input-bordered" value={password} onChange={(e) => setPassword(e.target.value)} required />
            </div>
            {error && <p className="text-error text-sm mt-2">{error}</p>}
            <div className="card-actions justify-end mt-4">
              <button type="submit" className="btn btn-primary" disabled={loading}>{loading ? "Logging in..." : "Login"}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
